import { Box, Typography } from "@mui/material";
import { ContentContainer } from "./ContentContainer";

export const Header = () => {
  return (
    <ContentContainer>
      <Box sx={{ paddingLeft: { sm: 7 }, paddingRight: { sm: 7 } }}>
        <Typography variant="h5" marginBottom={3} fontWeight={700}>
          Idea Vanicharoenchai
        </Typography>
        <Typography variant="subtitle1" lineHeight={1.5}>
          Hey, I'm Idea! Welcome to my personal website. Feel free to scroll
          down and explore my journey, experiences, and what I've been working
          on!
        </Typography>
      </Box>
    </ContentContainer>
  );
};
